import { IResource } from "../i18n";

const translation_sr_cyrl: IResource = {
    header_title: 'MEET | састанци без муке',
    header_menu_api: 'АПИ',
    header_signup_text: 'Бесплатна регистрација',
    header_signin_text: 'Пријава',
    header_dashboard_text: 'Мој Меет',

    general_title_text: 'Састанци без муке',
    general_cta_text_one: 'Уштедите време, новац и живце',
    general_cta_text_two: 'организујући и одржавајући',
    general_cta_text_three: 'интервјуе преко интернета',
    general_cta_button: 'Бесплатна проба',
    general_cta_contact: 'Контакт: office@meet.rs',
    general_tos_text: 'Услове коришћења',
    general_tos_tooltip: 'Вивани Meet услови коришћења',
    general_cookies_text: 'Политику интернет колачића',
    general_cookies_tooltip: 'Вивани Meet политика колачића',
    general_privacy_text: 'Политику приватности',
    general_privacy_tooltip: 'Вивани Meet политика приватности',
    general_refund_text: 'Услове повраћаја',
    general_refund_tooltip: 'Вивани Meet политика повраћаја новца',

    general_cta_consent_one: 'Овај сајт користи колачиће искључиво за аналитику и персонализацију сајта.',
    general_cta_consent_two: 'Коришћењем овог сајта прихватате ',

    usecase_title_head: 'Плански направљен за интернет интервјуе',
    usecase_title_subhead: 'Meet је дизајниран у потпуности на бази потреба послодаваца данас',
    usecase_interviewer_title: 'ПОМАЖЕ ПОСЛОДАВЦУ',
    usecase_interviewer_subtitle: 'Библиотека задатака',
    usecase_interviewer_body: 'Подесите задатке интервјуа унапред из библиотеке задатака',
    usecase_interviewer_learnmore: 'Више информација',
    usecase_interviewer_imgalt: 'Интервју на табли',
    usecase_collaboration_title: 'САРАЂУЈТЕ НА ЗАДАЦИМА',
    usecase_collaboration_subtitle: 'Направљен за сарадњу',
    usecase_collaboration_body_one: 'Разговарајте, кодирајте, цртајте, пишите ...',
    usecase_collaboration_body_two: 'Све то заједно и истовремено',
    usecase_collaboration_learnmore: 'Више информација',
    usecase_collaboration_imgalt: 'Интервју на табли',    
    usecase_recruiter_title: 'ПОМАЖЕ РЕКРУТЕРИМА',
    usecase_recruiter_subtitle: 'Преузима део посла рекрутера',
    usecase_recruiter_body: 'Аутоматско заказивање термина, хватање белешки,слање подсетника учесницима, прикупљање повратних инфромација...',
    usecase_recruiter_learnmore: 'Више информација',
    usecase_recruiter_imgalt: 'Интервју на табли',    
    usecase_call_title: 'HD ГРУПНИ ВИДЕО ПОЗИВ',
    usecase_call_subtitle: 'Са снимањем и транскрипцијом позива',
    usecase_call_body_one: 'Без икаквих инсталација на рачунару',
    usecase_call_body_two: 'Ради на свим модерним претраживачима на компјутеру и мобилним телефонима.',
    usecase_call_learnmore: 'Више информација',
    usecase_call_imgalt: 'Интервју на табли',  

    footer_email_text: "Контактирајте нас",

    signout_menu_text: "Одјава",
    me_menu_text: "Мој Меет",

    help_menu_text: "Помоћ",

    cta_nosignup_text:  "Без потребе за налогом и скидањем апликација",

    // Change language
    language_selector_title: "Језик",
    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsch",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    general_cta_button_quick: "Брзи састанак",
    general_cta_text_all: "Уштедите време, новац и живце организујући и одржавајући интервјуе преко интернета",
    
    header_title_short: "Vivani Meet",
}

export default translation_sr_cyrl;